var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('v-container',{attrs:{"fluid":""}},[_c('v-list',_vm._l((_vm.list),function(item){return _c('v-list-tile',{key:item.id,attrs:{"to":item.name}},[_vm._v(_vm._s(_vm.$t(("dictionaries__" + (item.name)))))])}))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }